import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { useId } from 'utils/hooks';

/**
 * @param {React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
 *  label?: string,
 *  caption?: string,
 *  tooltipText?: string,
 *  value?: string,
 *  onChange?: (value: string, event: React.ChangeEvent<HTMLTextAreaElement>) => void,
 *  rows?: number,
 *  disabled?: boolean,
 *  error?: string,
 *  className?: string,
 *  textareaClassName?: string,
 *  textareaProps?: React.TextareaHTMLAttributes<HTMLTextAreaElement>
 *  children?: React.ReactNode,
 *  inputRef?: React.RefObject<HTMLTextAreaElement>,
 * }} props
 */
export default function Textarea({
  id = '',
  label = '',
  tooltipText = '',
  value = '',
  onChange = () => {},
  rows = 4,
  disabled = false,
  error = '',
  className = '',
  textareaClassName = '',
  caption = '',
  children = null,
  inputRef = null,
  ...textareaProps
}) {
  const internalId = useId();
  const inputId = id || internalId;

  return (
    <div className={cn(styles.container, className)}>
      <UiKit.Label htmlFor={inputId} text={label} tooltipText={tooltipText}>
        <div className={styles.content}>
          <textarea
            ref={inputRef}
            id={inputId}
            rows={rows}
            value={value}
            onChange={e => onChange(e.target.value, e)}
            disabled={disabled}
            className={cn(styles.textarea, textareaClassName)}
            data-error={!!error}
            {...textareaProps}
          />
          {children}
        </div>
      </UiKit.Label>
      <UiKit.Error msg={error} hide={disabled} />
      <UiKit.Caption>{caption}</UiKit.Caption>
    </div>
  );
}
